import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing }) => ({
  statusBox: {
    width: "100%",
    height: "100%",
    gap: spacing(2),
    padding: spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  }
}))
